import { render } from "./HeroiconsSolidScissors.vue?vue&type=template&id=8eeb81f4"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidScissors.vue"]])

export default __exports__